import React from 'react';
import { skills } from '../../portfolio';

const Skills = () => {
  return (
    <section className="section">
      <div className="section-header">
        <h1 className="section-title">Skills</h1>
        <p className="section-subtitle">Technical proficiency, libraries, and architecture tooling.</p>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginTop: '32px' }}>
        {skills.map((skill, idx) => (
          <div key={idx} style={{ padding: '12px 24px', background: 'var(--surface)', borderRadius: '30px', border: '1px solid var(--border)', fontSize: '15px', color: 'var(--text-1)', fontWeight: 500 }}>
            {skill}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
